---
import type { Mark, Props as $ } from "../lib/types";
import { usePortableText } from "../lib/utils";

export type Props = $<Mark>;

const props = Astro.props;
const { node, index, isInline, ...attrs } = props;
const markTypeIs = (markType: string) => markType === node.markType;

const { getUnknownComponent } = usePortableText(node);

const UnknownMarkType = getUnknownComponent();
---

{
  markTypeIs("code") ? (
    <code {...attrs}><slot /></code>
  ) : markTypeIs("em") ? (
    <em {...attrs}><slot /></em>
  ) : markTypeIs("link") ? (
    <a href={(node as unknown as Mark<{ href: string }>).markDef.href} {...attrs}><slot /></a>
  ) : markTypeIs("strike-through") ? (
    <del {...attrs}><slot /></del>
  ) : markTypeIs("strong") ? (
    <strong {...attrs}><slot /></strong>
  ) : markTypeIs("underline") ? (
    <span style="text-decoration: underline;" {...attrs}><slot /></span>
  ) : (
    <UnknownMarkType {...props}><slot /></UnknownMarkType>
  )
}
